"use strict";

exports.__esModule = true;
exports.getStatesForActivity = getStatesForActivity;
var _getPlantState = require("./getPlantState");
/**
 * Use the mapping data to pull out the states for the given activity
 */
function getStatesForActivity(activityId, plantStateActivities) {
  return plantStateActivities.mapping.reduce(function (arr, map) {
    map.activities.forEach(function (item) {
      if (item.id === activityId) {
        arr.push(Object.assign({
          state: (0, _getPlantState.getPlantState)(plantStateActivities.states, map.stateId)
        }, item));
      }
    });
    return arr;
  }, []);
}